export default function Page({ title, children }) {
  document.title = `${title} - Nstream`;

  return <>{children}</>;
}
